/**
 * Estado da sessão para a UI.
 *
 * A UI só precisa de três estados: carregando, dentro, fora. Um `null` de
 * "ainda não sei" tratado como "fora" joga o usuário no login em todo refresh —
 * por isso `loading` é um estado explícito, e as guardas de rota respeitam ele.
 */
import { authClient } from '../lib/auth';

export type SessionStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  emailVerified: boolean;
  image: string | null;
}

export interface SessionState {
  status: SessionStatus;
  user: SessionUser | null;
}

export function useSession(): SessionState {
  const { data, isPending } = authClient.useSession();

  if (isPending) return { status: 'loading', user: null };

  const user = data?.user;
  if (!user) return { status: 'unauthenticated', user: null };

  return {
    status: 'authenticated',
    user: {
      id: user.id,
      name: user.name,
      email: user.email,
      emailVerified: user.emailVerified,
      image: user.image ?? null,
    },
  };
}
